import { render, staticRenderFns } from "./dock-to-stock-report.vue?vue&type=template&id=b3812cce&"
import script from "./js/dock-to-stock-report.js?vue&type=script&lang=js&"
export * from "./js/dock-to-stock-report.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports